
import { Component, Vue, } from 'vue-property-decorator';
import { isBadRequestResult, } from '~/api/error-helpers';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import LoginContentTile from '~/components/self-serve/login-content-tile/login-content-tile.vue';
import LoginForm from '~/components/self-serve/login-form/login-form.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';

@Component({
	components: {
		FeedbackBox,
		HeaderText,
		LoginForm,
		LoginContentTile,
		UnauthedNav,
	},
	metaInfo: {
		title: 'Register - Success - Southern Water',
	},
})
export default class RegistrationSuccess extends Vue {

	apiError: string | null = null;
	registerSuccess = false;
	registerLinkExpire = false;
	registerAlready = false;
	registerError = false;
	getLayout = document.querySelector('.layout');

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	mounted() {
		Store.commit.register.setStep(4);
		const parameters = this.$route.query;
		if (parameters && parameters.token && typeof parameters.token === 'string') {
			this.activate(parameters.token);
		} else {
			this.apiError = this.invalidTokenMessage();
		}
	}

	beforeDestroy() {
		Store.commit.register.registrationSuccessShowHeader(true);
	}

	activate(token: string) {
		this.apiError = null;
		if (!token) {
			return;
		}

		Store.commit.showSpinner();

		this.$selfServeApi.registerAccountActivateAccountCreate({
			activationCode: token,
		})
			.then(() => {
				this.registerSuccess = true;
				Store.commit.register.registrationSuccessShowHeader(false);
			})
			.catch((error) => {
				this.registerSuccess = false;
				Store.commit.register.registrationSuccessShowHeader(true);
				let apiError = `Please wait a few minutes and try again. If the problem persists, please <a target="_blank" href=${this.contactUsLocation}>contact us</a>.`;
				if (isBadRequestResult(error) && Array.isArray(error.errors)) {
					if (error.errors[0].metadata.Number === '0014') {
						this.registerLinkExpire = true;
						return;
					} else if (error.errors[0].metadata.Number === '005') {
						this.registerAlready = true;
						Store.commit.register.registrationSuccessShowHeader(false);
						return;
					} else if (error.errors[0].metadata.Number === '022') {
						this.registerError = true;
						return;
					} else if (error.errors[0].metadata.Number === '300') {
						apiError = this.invalidTokenMessage();
					} else {
						apiError = error.errors[0].message;
					}
				}
				this.apiError = apiError;
			}).finally(() => Store.commit.hideSpinner());
	}

	invalidTokenMessage() {
		return 'Sorry, this link has now expired. You’ll need to complete a new registration.';
	}

	reload() {
		window.location.reload();
	}

	goToRegister() {
		this.$router.push('/register');
	}

	loginContentTiles = Store.state.customContent.loginContentTiles;

	get loginPromoBanner() {
		return Store.state.customContent.loginPromoBanner;
	}

	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');
}
